"use client";

import DesktopNav from "./Desktopnav";
import MobileNav from "./Mobilenav";
import { useAuthInit } from "./useAuthUser";

// Laptop/Desktop (ab 1024 px): DesktopNav
// Handy/Tablet (unter 1024 px):  MobileNav
const Navbar = () => {
    useAuthInit();

    return (
        <>
            <DesktopNav />
            <MobileNav />
        </>
    );
};

export default Navbar;
